import React from 'react';
import { Route, Switch } from 'react-router';
import { Footer, Layout } from '@legalshield/adonis-ux-framework';

import EntitlementBenefit from '../EntitlementBenefit';
import ProductBenefit from '../ProductBenefit';
import EmptyContent from '../EmptyContent';

export const App: React.FC = () => (
  <Layout variant="scroll">
    <div>
      <Switch>
        <Route path="/entitlement/:entitlementID" component={EntitlementBenefit} />
        <Route path="/product" component={ProductBenefit} />
        <Route path="*" component={EmptyContent} />
      </Switch>
    </div>
    <Footer classNames={['lsux-layout-padding']} htmlContent={footerHtml} />
  </Layout>
);
